import { ScheduledQueryCadence } from '@api/api/scheduled-queries';

import type { PromptFormValue } from '../PromptForm';

export const buildCadence = (
  value: PromptFormValue,
  timezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone
): ScheduledQueryCadence | undefined => {
  if (!value.scheduleEnabled) {
    return undefined;
  }

  const { frequency } = value;
  const isMonthlyByDate = frequency === 'monthlyByDate';

  return {
    frequency: isMonthlyByDate ? 'monthly' : frequency,
    time_window: value.deliveryTime,
    timezone,
    ...(frequency === 'daily' && {
      skip_weekends: value.skipWeekends,
    }),
    ...(isMonthlyByDate && {
      day_of_month: value.dayOfMonth,
      ...(value.rollToBusinessDay && { roll_to_business_day: true }),
    }),
    ...((frequency === 'weekly' || frequency === 'monthly') && {
      day_of_week: value.day,
    }),
    ...(frequency === 'monthly' && {
      occurrence: value.occurrence,
    }),
  };
};
